import { VariableCardListCombinedProps } from './types';

const usePresenter = (props: VariableCardListCombinedProps): VariableCardListCombinedProps => {
  return props;
};

export default usePresenter;
